import React from 'react'
import PropTypes from 'prop-types'

const DrawerToggleButton = ({ click }) => (
  <button type="button" className="togglebutton" title="Menu" onClick={click}>
    <div className="w-8 h-1 bg-blue-500" />
    <div className="w-8 h-1 bg-blue-500" />
    <div className="w-8 h-1 bg-blue-500" />
  </button>
)

DrawerToggleButton.propTypes = {
  click: PropTypes.func,
}

export default DrawerToggleButton
